'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Column = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ColumnStyled = require('./styles/ColumnStyled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  /**
   * Shows how much space takes the column on different screen sizes.
   * Total number of columns: 12.
   */
  size: _propTypes2.default.shape({
    xsmall: _propTypes2.default.number,
    small: _propTypes2.default.number,
    medium: _propTypes2.default.number,
    large: _propTypes2.default.number,
    xlarge: _propTypes2.default.number
  }),
  /** Set content flow direction */
  layoutDirection: _propTypes2.default.oneOf(['horizontal', 'vertical']),
  /**
   * Set content align along main axis
   * Main axis for layoutDirection = horizontal equals x-axis,
   * and for layoutDirection = vertical it equals y-axis
   */
  mainAxisAlign: _propTypes2.default.oneOf(['start', 'end', 'center', 'evenSpaceBetween', 'evenSpaceAround']),
  /**
   * Set content align along cross axis
   * Cross axis for layoutDirection = horizontal equals y-axis,
   * and for layoutDirection = vertical it equals x-axis
   */
  crossAxisAlign: _propTypes2.default.oneOf(['start', 'end', 'center', 'stretch', 'baseline']),
  /**
   * Shows on which screens block should be centered.
   * Centering starts from the smallest breakpoint, marked as true, up to
   * the next breakpoint marked as false.
   */
  centered: _propTypes2.default.shape({
    xsmall: _propTypes2.default.bool,
    small: _propTypes2.default.bool,
    medium: _propTypes2.default.bool,
    large: _propTypes2.default.bool,
    xlarge: _propTypes2.default.bool
  }),
  /** Removes column paddings */
  collapsed: _propTypes2.default.bool
};

var defaultProps = {
  size: { xsmall: 12 },
  layoutDirection: 'vertical',
  mainAxisAlign: 'start',
  crossAxisAlign: 'start',
  centered: null,
  collapsed: false
};

var Column = exports.Column = function Column(props) {
  return _react2.default.createElement(
    _ColumnStyled.ColumnStyled,
    {
      collapsed: props.collapsed,
      centered: props.centered,
      layoutDirection: props.layoutDirection,
      mainAxisAlign: props.mainAxisAlign,
      crossAxisAlign: props.crossAxisAlign,
      size: props.size
    },
    props.children
  );
};

Column.propTypes = propTypes;
Column.defaultProps = defaultProps;
Column.displayName = 'Column';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-grid/dist/Column/Column.js
// module id = 683
// module chunks = 0